/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type {
  IERC1271,
  IERC1271Interface,
} from "../../../../../@gnosis-guild/zodiac-core/contracts/signature/IERC1271";

const _abi = [
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "hash",
        type: "bytes32",
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes",
      },
    ],
    name: "isValidSignature",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

export class IERC1271__factory {
  static readonly abi = _abi;
  static createInterface(): IERC1271Interface {
    return new Interface(_abi) as IERC1271Interface;
  }
  static connect(address: string, runner?: ContractRunner | null): IERC1271 {
    return new Contract(address, _abi, runner) as unknown as IERC1271;
  }
}
